import type { IconType } from 'react-icons';
import { BiAnchor, BiFoodMenu, BiParty } from 'react-icons/bi';
import { GrCompliance, GrDeliver } from 'react-icons/gr';
import {
  HiMiniWrenchScrewdriver,
  HiOutlineBuildingOffice2,
  HiOutlineSparkles,
} from 'react-icons/hi2';
import { IoDocumentTextOutline } from 'react-icons/io5';
import {
  MdOutlineCleaningServices,
  MdOutlineLocalGasStation,
  MdOutlinePeopleAlt,
  MdOutlineSubscriptions,
} from 'react-icons/md';
import { RiShipLine } from 'react-icons/ri';

import AdditionalIcon from '@assets/equipment/icon-park-solid_other.svg?react';

export const ICON_REGISTRY: Record<string, IconType> = {
  RiShipLine,
  HiOutlineSparkles,
  MdOutlineCleaningServices,
  HiMiniWrenchScrewdriver,
  IoDocumentTextOutline,
  GrCompliance,
  BiParty,
  MdOutlineLocalGasStation,
  HiOutlineBuildingOffice2,
  BiAnchor,
  MdOutlinePeopleAlt,
  GrDeliver,
  BiFoodMenu,
  MdOutlineSubscriptions,
};

export const DEFAULT_CATEGORY_ICON = AdditionalIcon as unknown as IconType;

export const resolveIcon = (name: string | undefined): IconType =>
  (name && ICON_REGISTRY[name]) || DEFAULT_CATEGORY_ICON;
